import { __assign } from "tslib";
import * as React from 'react';
import { NavLink } from 'react-router-dom';
export var HeaderLink = function (props) { return (React.createElement("li", { className: "h2" },
    React.createElement(NavLink, __assign({}, props, { className: "nav-link" })))); };
//# sourceMappingURL=HeaderLink.js.map